'use strict';

let _ = require('lodash');

class Factory {
    static _validate(attributeConfigs) {
        if (_.isNil(attributeConfigs)) {
            throw new Error('attributeConfigs must not be null or undefined.');
        }
    }
}

module.exports = Factory;
